<script>
  import { ascending, max, extent } from 'd3-array';
  import { scaleLinear } from 'd3-scale';
  import { formatStr, formatIncome } from '../utils/format.js';
  import { colorScale } from '../utils/color.js';
  import Legend from './Legend.svelte';

  import { selNbh, isMobile } from '../store.js';

  export let data;
  $: neighborhood = $selNbh;

  let latino = data
    .slice()
    .sort((a, b) => ascending(a.latino_percent, b.latino_percent));
  let black = data
    .slice()
    .sort((a, b) => ascending(a.black_percent, b.black_percent));
  let asian = data
    .slice()
    .sort((a, b) => ascending(a.asians_all_percent, b.asians_all_percent));
  let white = data
    .slice()
    .sort((a, b) => ascending(a.white_percent, b.white_percent));
  let income = data
    .slice()
    .sort((a, b) => ascending(a.more_than_60000_pct, b.more_than_60000_pct));
  let renters = data
    .slice()
    .sort((a, b) => ascending(a.renter_percent, b.renter_percent));

  $: demo_datasets = [
    {
      name: 'latino',
      data: latino,
      overall: 0.48,
      label: 'Latino',
      col: 'latino_percent',
    },
    {
      name: 'black',
      data: black,
      overall: 0.08,
      label: 'Black',
      col: 'black_percent',
    },
    {
      name: 'asians_all',
      data: asian,
      overall: 0.12,
      label: 'Asian',
      col: 'asians_all_percent',
    },
    {
      name: 'white',
      data: white,
      overall: 0.28,
      label: 'white',
      col: 'white_percent',
    },
    {
      name: 'income',
      data: income,
      overall: 0.53,
      label: 'Median income',
      col: 'more_than_60000_pct',
    },
    {
      name: 'renter',
      data: renters,
      overall: 0.63,
      label: 'Renter',
      col: 'renter_percent',
    },
  ];

  let height = 100;
  // const maxIncome = max(income, (d) => d.median_householdincome);
  // const y = scaleLinear().domain([0, maxIncome]).range([0, height]);

  $: labelHeight = $isMobile ? 150 : 120;
</script>

<div class="demo-label header">How L.A. neighborhoods voted by demographic</div>
<div class="demo-description">
  <p class="prose">Each bar below represents a neighborhood. The color corresponds to the gap between the leading and trailing candidate in that neighborhood. The darker the color the larger the gap.</p>
  <p class="prose">Majority Latino neighborhoods split the vote between the two candidates. Neighborhoods with a Black majority voted heavily for Bass, as indicated by the darker purple, while neighborhoods with a white majority voted for Caruso. Wealthier neighborhoods heavily favored Caruso.</p>
  <div id="nbhdescription-container" />
</div>
<Legend />
{#each demo_datasets as demo, idx}
  <div class="temp-outer-container">
    <div class="temp-container">
      <div class="axis">
        <div class="axis__tick" />
        <p class="axis__text">100%</p>
      </div>
      <div class="bars">
        {#each demo.data as obj}
          <div
            class="temp-bar {formatStr(obj.neighborhood)}"
            id=""
            style="height:{obj[`${demo.col}`] * height}px; top:{(1 -
              obj[`${demo.col}`]) *
              height}px; background-color:{colorScale(obj.nbh_vote_margin)};
              border:{obj.neighborhood == neighborhood
              ?  obj[`${demo.col}`] < 0.01 ? '0.2px dashed #000' : '1.5px dashed #000'
              : 'none'};"
          >
            {#if obj.neighborhood == neighborhood}
              <!-- {#if $isMobile} -->
              <div
                style="top:{-labelHeight -
                  -obj[`${demo.col}`] * height}px; height:{labelHeight -
                  obj[`${demo.col}`] * height}px;z-index:50;"
                class="demo-neighborhood-label"
              >
                <div class="demo-neighborhood-label__name">
                  {idx == 0 ? neighborhood : ''}
                  <span>
                    {`${
                        obj[`${demo.col}`] < 0.01
                            ? Math.round(10000 * obj[`${demo.col}`]) /
                              100
                            : Math.round(100 * obj[`${demo.col}`])
                        }%`
                      }
                  </span>
                </div>
              </div>
            {/if}
          </div>
        {/each}

        <div class="median-bar" style="top:{(1 - demo.overall) * height}px;" />
        <div
          class="median-label"
          style="top:{(1 - demo.overall) * height - 22}px;"
        >
          {#if demo.name == 'income'}
            <span style="font-weight: bold;">53%</span> of L.A. households make above
            $60k
          {:else}
            L.A. is {Math.round(demo.overall * 100)}%
            <span style="font-weight: bold;">{demo.label}</span>
          {/if}
        </div>
      </div>
      <div class="axis">
        <div class="axis__tick" />
        <p class="axis__text">0</p>
      </div>
    </div>
    {#if idx == 0}
      <div class="demo-axis-label">All neighborhoods</div>
    {/if}
  </div>
{/each}
